<template>
  <Row>
    <i-col span="15">
      <template v-if="edit">
        <Row>
          <i-col span="24">
            <i-select
              v-model="currentID"
              @on-change="setCurrentOption"
              filterable
              remote
              :remote-method="search"
              style="padding-right:6px;"
              not-found-text="Events require matching fields 'Displacement type' and 'Year' to be provided"
            >
              <i-option
                v-for="option in options"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              >
                <div>
                  <strong>{{ option.name }}</strong>
                </div>
                <div>
                  <small>
                    {{ option.id }} / {{ option.displacement_type }} /
                    <span v-if="option.displacement_type === 'Disaster'"
                      >{{ option.category }} / {{ option.type }} /</span
                    >
                    <span v-if="option.start_date">
                      {{ option.start_date }}</span
                    >
                    <strong v-else style="color:red;"> ?</strong>
                  </small>
                </div>
              </i-option>
            </i-select>
          </i-col>
        </Row>
      </template>
      <template v-else>
        <Row>
          <i-col span="24">
            <i-input
              :value="currentOption && currentOption.name"
              readonly
              style="padding-right:6px;"
            >
              <i-button slot="append" icon="md-create" @click="setEdit(true)"
                >edit</i-button
              >
            </i-input>
          </i-col>
        </Row>
      </template>
    </i-col>
    <i-col span="6">
      <i-select
        v-model="currentRole"
        clearable
        style="padding-right:6px;"
        @on-change="updateValue"
      >
        <i-option value="Recommended figure">Recommended figure</i-option>
        <i-option value="Partial figure (Added)"
          >Partial figure (Added)</i-option
        >
        <i-option value="Partial figure (Subtracted)"
          >Partial figure (Subtracted)</i-option
        >
        <i-option value="Triangulation">Triangulation</i-option>
      </i-select>
    </i-col>
    <i-col span="3">
      <i-button
        icon="alert-circled"
        @click="clear"
        :disabled="currentOption === null"
        style="width:100%;"
        >Clear</i-button
      >
    </i-col>
  </Row>
</template>

<script>
import _ from "lodash";
import axios from "axios";
// import Multiselect from "vue-multiselect";
import { getTsQueryValue } from "@/utils/common";

export default {
  Name: "MasterFactAssociation",
  components: {
    // Multiselect
  },
  props: {
    id: Number,
    role: String,
  },
  data() {
    return {
      edit: false,
      loading: false,
      options: [],
      currentID: null,
      currentOption: null,
      currentRole: this.role,
    };
  },
  filters: {
    getFigureDate(entity) {
      let date = null;
      if (_.includes(entity.type, "Stock")) {
        date = entity.stock_date;
      } else {
        date = entity.start_date;
      }
      return date !== null ? date : "";
    },
  },
  watch: {
    id(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadOptionByID(newValue);
      }
    },
    role(newValue) {
      this.currentRole = newValue;
    },
  },
  methods: {
    setEdit(value) {
      this.edit = value;
      if (value) {
        this.options = [];
        this.currentID = null;
      }
    },
    async loadOptionByID(id) {
      if (id) {
        this.loading = true;
        try {
          let response = await axios.get(`/psql/events_view`, {
            params: {
              select: "id,name,displacement_type,type,category,start_date",
              id: `eq.${id}`,
            },
            headers: { Accept: "application/vnd.pgrst.object+json" },
          });
          this.currentOption = response.data;
          this.loading = false;
        } catch (error) {
          // this.$Message.error("Error loading events list");
          console.error(error.response);
        }
      } else {
        this.options = [];
      }
    },
    clear() {
      this.$Modal.confirm({
        title: `Clear Event`,
        content: `This will deassociate the fact from the event, are you sure?`,
        onOk: () => {
          this.$emit("change", { id: null, role: null });
        },
      });
    },
    setCurrentOption(value) {
      this.currentOption = this.options.find(option => option.id === value);
      this.updateValue();
      this.edit = false;
    },
    updateValue() {
      this.$nextTick(() => {
        this.$emit("change", {
          id: this.currentOption.id,
          role: this.currentRole ? this.currentRole : "Recommended figure",
        });
      });
    },
    async search(query) {
      if (query && query.trim().length >= 3) {
        this.loading = true;
        try {
          let response = await axios.get(`/psql/events_view`, {
            params: {
              select: "id,name,displacement_type,type,category,start_date",
              name: getTsQueryValue(query),
            },
            limit: 30,
          });
          this.options = response.data;
          this.loading = false;
        } catch (error) {
          // this.$Message.error("Error loading events list");
          console.error(error.response);
        }
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<style lang="css">
.multiselect__tags {
  min-height: 32px !important;
}
.multiselect__single {
  width: unset !important;
  font-size: 12px !important;
  padding-left: 5px !important;
  margin: 4px !important;
}
.multiselect__select:before {
  top: 55% !important;
}
.multiselect__input {
  margin: 4px 0px 4px 0px !important;
  font-size: 12px;
}
</style>
